import React, { useEffect } from "react";
import Modal from "@/components/ui/Modal";
import CalendlyEmbed from "@/components/CalendlyEmbed";

type CalendlyModalProps = {
  isOpen: boolean;
  onClose: () => void;
  eventType?: "general" | "wedding" | "corporate" | "private_party";
  location?: string;
};

const CalendlyModal: React.FC<CalendlyModalProps> = ({
  isOpen,
  onClose,
  eventType = "general",
  location = "calendly_modal",
}) => {
  // Track modal open
  useEffect(() => {
    if (isOpen && typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];

      // Clear all tracking variables first (prevents data pollution)
      // NOTE: button_text, button_location, parent_modal, and event_type are preserved to retain context
      window.dataLayer.push({
        // Clear modal variables (will be reset below)
        modal_type: undefined,
        modal_name: undefined,
        // parent_modal: undefined,    // ← Keep this! (shows if opened from another modal)
        page_location: undefined,
        // Preserve button variables (retain context of triggering action)
        // button_text: undefined,     // ← Keep this!
        // button_location: undefined, // ← Keep this!
        // Clear booking variables
        room_type: undefined,
        // Clear contact action variables
        contact_type: undefined,
        contact_source: undefined,
        event_category: undefined,
        event_label: undefined,
        phone_number: undefined,
        email_address: undefined,
        whatsapp_number: undefined,
        region: undefined,
        destination: undefined,
        booking_method: undefined,
        // Clear event consultation variables (but preserve event_type!)
        // event_type: undefined,      // ← Keep this! (shows which event type user is interested in)
        consultation_method: undefined,
        service_category: undefined,
        // Clear Calendly variables
        calendly_action: undefined,
        calendly_location: undefined,
      });

      // Now push the actual modal open event with clean data
      window.dataLayer.push({
        event: "modal_open",
        modal_type: "calendly",
        modal_name: "calendly_consultation",
        page_location: window.location.pathname,
      });
    }
  }, [isOpen]);

  // Clear consultation variables when modal closes
  const handleClose = () => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];

      // Clear consultation and button variables to prevent pollution
      window.dataLayer.push({
        // Clear button variables
        button_text: undefined,
        button_location: undefined,
        // Clear modal variables
        modal_type: undefined,
        modal_name: undefined,
        page_location: undefined,
        // Clear consultation variables
        event_type: undefined,
        consultation_method: undefined,
        service_category: undefined,
        // Clear Calendly variables
        calendly_action: undefined,
        calendly_location: undefined,
      });
    }

    // Call the original onClose
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      hideChrome
      keepMounted
      className="max-w-5xl"
      data-oid="anj2tco"
    >
      <CalendlyEmbed
        className="rounded-lg overflow-hidden"
        height={760}
        eventType={eventType}
        location={location}
        disableViewTracking={true} // Modal tracks modal_open instead
        data-oid=".sydb28"
      />
    </Modal>
  );
};

export default CalendlyModal;
